<template>

    <dynamic-profiling v-if="questions.length > 0"
                       :questions="questions"
                       :locale="locale"
                       :settings="settings"
                       :edit-mode="editMode"
                       :translations="translations"
                       :loading="loading"
                       :saving="saving"
                       @save="saveAnswer"
                       @completed="updateCompletedCount"
                       @remaining="updateRemainingCount">
    </dynamic-profiling>

</template>

<script>

// import CheckboxQuestion from "@/components/UI/DynamicProflingQuestions/CheckboxQuestion.vue";
// import DateQuestion from "@/components/UI/DynamicProflingQuestions/DateQuestion.vue";
// import EmailQuestion from "@/components/UI/DynamicProflingQuestions/EmailQuestion.vue";
// import KeywordQuestion from "@/components/UI/DynamicProflingQuestions/KeywordQuestion.vue";
// import LocaleQuestion from "@/components/UI/DynamicProflingQuestions/LocaleQuestion.vue";
// import NumberQuestion from "@/components/UI/DynamicProflingQuestions/NumberQuestion.vue";
// import RadioQuestion from "@/components/UI/DynamicProflingQuestions/RadioQuestion.vue";
// import TextQuestion from "@/components/UI/DynamicProflingQuestions/TextQuestion.vue";
// import PhoneQuestion from "@/components/UI/DynamicProflingQuestions/PhoneQuestion.vue";
import Api from "@/api.js";
import colorMixin from "@/components/mixins/colorMixin.js";
import Question from "@/modules/RegistrationSurvey/ts/Question.ts";
import DynamicProfiling from "@/components/UI/DynamicProfiling.vue";

export default {

    name: "DynamicProfilingLanding",

    mixins: [colorMixin],

    components: {
        DynamicProfiling,
        // CheckboxQuestion,
        // DateQuestion,
        // EmailQuestion,
        // KeywordQuestion,
        // LocaleQuestion,
        // NumberQuestion,
        // RadioQuestion,
        // TextQuestion,
        // PhoneQuestion
    },

    props: {

        settings: {
            type: Object,
            required: true,
        },
        editMode: {
            type: Boolean,
            required: true,
        },
        translations: {
            type: Object,
            required: true,
        },
        headerText: {
            type: String | null,
            required: false,
            default: null
        }
    },

    data() {
        return {
            activeQuestion: null,
            activeQuestionIndex: 0,
            questions: [],
            loading: false,
            saving: false,
            locale: null,
            requestQueue: [],
            remainingCount: 0,
            completedCount: 0,
        }
    },

    methods: {

        updateCompletedCount(count) {
            this.completedCount = count;
            this.$emit('completed', this.completedCount);
        },

        updateRemainingCount(count) {
            this.remainingCount = count;
            this.$emit('remaining', this.remainingCount);
        },

        getQuestions() {

            if (this.editMode) return;

            this.loading = true;

            Api.get('/dynamic-profiling/questions')

                .then((response) => {

                    response.data.questions.forEach(serverQuestion => {
                        this.questions.push(new Question(serverQuestion))
                    })

                    this.updateRemainingCount(this.questions.length);

                    this.locale = response.data.locale;

                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        saveAnswer(data) {

            if (this.editMode) return;

            this.saving = true;

            Api.post('/dynamic-profiling/answer', data)

                .then((response) => {

                    if (response.data.compensation && response.data.compensation > 0) {
                        this.$emit('reward', response.data.compensation);
                    }

                    if (this.remainingCount === 0) {
                        Bus.$emit('flash-message', {message: this.translations.dynamic_profiling_thank_you_text});
                    }
                })
                .catch(error => {

                    if (error.response && error.response.status === 409) {
                        // Do nothing, dynamic profiling is not enabled anymore or
                        // panelist has already provided an answer
                    } else {

                        console.log(error);

                        Bus.$emit('flash-message', {
                            type: 'error',
                            message: this.translations.dynamic_profiling_error_text
                        });
                    }
                })
                .finally(() => {
                    this.saving = false;
                });
        },
    },

    mounted() {
        this.getQuestions();
    }
}
</script>